import { render, staticRenderFns } from "./ClinicRecoveryModal.vue?vue&type=template&id=3b03805a&scoped=true"
import script from "./ClinicRecoveryModal.vue?vue&type=script&lang=js"
export * from "./ClinicRecoveryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b03805a",
  null
  
)

export default component.exports